export const MESSAGE_TYPE_BOOKING_CANCELLED = 'MESSAGE_TYPE_BOOKING_CANCELLED';
export const MESSAGE_TYPE_BOOKING_CREATED = 'MESSAGE_TYPE_BOOKING_CREATED';
export const MESSAGE_TYPE_BOOKING_PAID = 'MESSAGE_TYPE_BOOKING_PAID';
export const MESSAGE_TYPE_FILE = 'MESSAGE_TYPE_FILE';
export const MESSAGE_TYPE_TEXT = 'MESSAGE_TYPE_TEXT';
export const MESSAGE_TYPE_ASK_FOR_REVIEW = 'MESSAGE_TYPE_ASK_FOR_REVIEW';
export const MESSAGE_TYPE_COMMUNICATION_WARNING = 'MESSAGE_TYPE_COMMUNICATION_WARNING';
export const MESSAGE_TYPE_HOST_COMMUNICATION_WARNING = 'MESSAGE_TYPE_HOST_COMMUNICATION_WARNING';
export const DASHBOARD_REQUEST_REVIEW_NOTIFICATION = 'DASHBOARD_REQUEST_REVIEW_NOTIFICATION';
